<template>
  <section id="HomeApplicationSection">
    <div class="main_container">
      <div class="card_box">
        <div class="text_box">
          <p class="sub_title">
            {{ $store.getters.columnData("search_scooter_sub_title") }}
          </p>
          <h2 class="title">
            {{ $store.getters.columnData("search_scooter_title") }}
          </h2>
          <p class="content textarea_content">
            {{ $store.getters.columnData("search_scooter_content") }}
          </p>
        </div>
        <div class="action_box">
          <router-link to="/contact" class="main_button primary"
            >填寫表單
            <span class="icon material-symbols-rounded"> east </span>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeApplicationSection",
};
</script>
